import { filterObjectProps, convertEmptyStringsToNull } from "../../../pages/activityBuilder/modules/inputs/utils";
import {
	includedPropList,
	includedT2PropList,
	minorSeasonPropsList,
} from "../../../pages/activityBuilder/modules/perennialCropland/perennialCropland";
import type {
	MinorSeason,
	MinorSeasonT2,
	ModuleFull,
	PerennialCroplandPayload,
	PerennialCroplandsResponse,
	PerennialCroplandT2,
} from "../../../pages/activityBuilder/modules/perennialCropland/perennialCroplandTypes";
import { FEModulesObj } from "../../../utils/moduleList";
import { FEModules } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";

// Define constants for the module
const MODULE_TYPE = "PerennialCropland";
const TAG: TagTypes = "PerennialCropland";
const TAG_DEFAULTS: TagTypes = "PerennialCroplandDefaults";
const ENDPOINT = FEModulesObj[FEModules.PerennialCropland].path;
const t2PercentageProps = ["minor_biomass_factor_t2_start", "minor_biomass_factor_t2_w", "minor_biomass_factor_t2_wo"];

const transformResponse = (response: PerennialCroplandsResponse) => {
	if (response) {
		const moduleMinorSeasonData = filterObjectProps(
			response,
			minorSeasonPropsList,
		) as MinorSeason;

		const t2MinorSeasonData = filterObjectProps(response, t2PercentageProps) as MinorSeasonT2;

		const module = filterObjectProps(
			{ ...response, minorSeason: moduleMinorSeasonData },
			includedPropList,
		) as PerennialCroplandPayload;

		const t2 = filterObjectProps(
			{ ...response, minorSeason: t2MinorSeasonData },
			includedT2PropList,
		) as PerennialCroplandT2;
		return {
			module: module,
			tiertwo: t2,
		};
	}
	return null;
}

const perennialCroplandApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicPerennialCroplandApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

export const {
	useGetPerennialCroplandQuery,
	useGetPerennialCroplandDefaultsQuery
} = perennialCroplandApiSlice;

export const {
	useGetPerennialCroplandQuery: usePublicGetPerennialCroplandQuery,
	useGetPerennialCroplandDefaultsQuery: usePublicGetPerennialCroplandDefaultsQuery
} = publicPerennialCroplandApiSlice;

const transformUpdatePayload = (data: ModuleFull, activityId: number) => {
	const module = { ...data.module /* ...data.module.minorSeason */ };
	const tiertwo = { ...data.tiertwo /* ...data.tiertwo.minorSeason */ };
	const lucId = data.module.land_use_change;

	const payload = {
		...module,
		...tiertwo,
	} as unknown as PerennialCroplandsResponse;
	const { id, ...rest } = payload;
	const body = { ...rest, activity: activityId, land_use_change: lucId };

	convertEmptyStringsToNull(body);
	return { body, id };
}

const mutationApiSlice = createModuleUpdateApi<ModuleFull, PerennialCroplandsResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
	includesLandUseChange: true,
})

export const {
	useUpdatePerennialCroplandMutation,
} = mutationApiSlice;